module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_9016.50bb290e.png";